import { render, staticRenderFns } from "./BaseCircleLoader.vue?vue&type=template&id=2db21f88&scoped=true&"
import script from "./BaseCircleLoader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseCircleLoader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseCircleLoader.vue?vue&type=style&index=0&id=2db21f88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db21f88",
  null
  
)

export default component.exports